//vendors
import React, { ChangeEvent } from "react";
import classNames from "classnames";

//styles
import style from './textarea.module.scss';

type Props = {
  name?: string,
  disabled?: boolean,
  placeholder?: string,
  label?: string | JSX.Element,
  subLabel?: string,
  className?: string,
  horizontal?: boolean,
  value?: string | number,
  onChange: (value: string) => void,
  error?: string,
  onBlur?: () => void,
  touched?: boolean
  onKeyPress?: (e) => void,
  autoFocus?: boolean
  required?: boolean,
  fieldsProportions?: Array<number>
};

export const Textarea = (props: Props) => {
  const handlerOnChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    props.onChange(e.target.value);
  };
  
  return (
    <div className={classNames(
      style.textareaWrap,
      props.className,
      { [style.horizontal]: props.horizontal, [style.errorInput]: !!props.error && props.touched }
    )}>
      {props.label &&
        <label style={props.fieldsProportions ? {"flex": props.fieldsProportions[0]} : {}}>
          <div>{props.required && <span>* </span>}{props.label}</div>
          {props.subLabel && <p className={style.subLabel}>{props.subLabel}</p>}
        </label>
      }

      <div className={style.input} style={props.fieldsProportions ? {"flex": props.fieldsProportions[1]} : {}}>
        <textarea
          id={props.name}
          disabled={props.disabled}
          placeholder={props.placeholder}
          onChange={handlerOnChange}
          onBlur={props.onBlur}
          value={props.value}
          onKeyPress={props.onKeyPress}
          autoFocus={props.autoFocus}
        />

        {props.touched && props.error && <span className={style.error}>{props.error}</span>}
      </div>
    </div>
  )
}

Textarea.defaultProps = {
  disabled: false,
  horizontal: false,
  touched: false,
  autoFocus: false,
  required: false,
  value: ''
};
